/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import PropTypes from 'prop-types';

/**
 * Custom useSelectedStudio
 * @param setCurrentSelectedMarker
 */
export function useSelectedStudio(setCurrentSelectedMarker) {
  /**
     * Handle the click on the close button and close the selected marker detail overlay
     */
  const handleCloseStudioDetails = () => {
    setCurrentSelectedMarker(false);
  };

  return {
    handleCloseStudioDetails,
  };
}

useSelectedStudio.propTypes = {
  setCurrentSelectedMarker: PropTypes.func.isRequired,
};
